import styled from 'styled-components';

export const LoginInputLabel = styled.label`
    display: block;

    > input,
    select {
        display: block;
        margin-top: var(--size-grid-quarter);
    }
`;
